/* src/app/login/login.component.css */
.small-block {
  display: block;
  margin-top: 3px;
  margin-bottom: 5px;
}
.btn-custom {
  color: #0d6efd !important;
  padding-left: 0px;
  text-decoration: none !important;
  font-size: 1rem !important;
}
.btn-custom:hover {
  color: #0a58ca !important;
  text-decoration: none !important;
}
/*# sourceMappingURL=login.component.css.map */
